import Vue from 'vue'
import Vuex from 'vuex'
import customers from './customer.store'
import employees from './employee.store'
import masterboard from './masterboard.store'
import contacts from './contacts.store'
import jobLabor from './jobLabor.store'
import login from './login.store'
import jobMaterials from './jobMaterials.store'
import code from './codes.store'
import report from './report.store'
import workflows from './workflows.store'
import VuexPersistence from 'vuex-persist'

/**
 * Persistent Store
 *
 * The contents of this store persist between user sessions.
 */
export const vuexLocalStorage = new VuexPersistence({
  key: 'vuex-local-storage',
  storage: window.sessionStorage,
  modules: ['customers', 'employees']
})

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    customers,
    employees,
    contacts,
    masterboard,
    jobLabor,
    login,
    jobMaterials,
    code,
    report,
    workflows
  }
})
